module.exports = __webpack_public_path__ + "media/theme/blog__border-8-46b1900e.png";